import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import CategoryDetailAdvancedSeoCategoriesSlider from 'components/Pages/CategoryDetail/CategoryDetailAdvancedSeoCategories/CategoryDetailAdvancedSeoCategoriesSlider/CategoryDetailAdvancedSeoCategoriesSlider';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import useTranslation from 'next-translate/useTranslation';
import { twJoin } from 'tailwind-merge';
import { ReadyCategorySeoMixLink } from 'types/category';

type Props = {
    readyCategorySeoMixLinks: ReadyCategorySeoMixLink[];
};

export const categoryDetailAdvancedSeoCategoriesItemTwClass = (): string =>
    twJoin(
        'p-3 flex items-center justify-center rounded-lg bg-grayVeryLight text-center text-small leading-6 text-primary no-underline lg:mr-6 lg:mb-3',
        'hover:bg-blueVeryLight hover:text-primary hover:no-underline active:bg-blueVeryLight active:text-primary active:no-underline',
    );

const CategoryDetailAdvancedSeoCategories: FC<Props> = ({ readyCategorySeoMixLinks }) => {
    const { t } = useTranslation();

    const isDesktop = useMediaMin('lg');

    if (readyCategorySeoMixLinks.length === 0) {
        return null;
    }

    return (
        <>
            <h2>{t('Favorite categories')}</h2>
            {isDesktop ? (
                <div className="-mr-6 mb-2 flex flex-row flex-wrap">
                    {readyCategorySeoMixLinks.map((seoMixLink, index) => (
                        <ExtendedNextLink
                            key={index}
                            className={categoryDetailAdvancedSeoCategoriesItemTwClass()}
                            href={`/${seoMixLink.slug}`}
                            type="category"
                        >
                            {seoMixLink.name}
                        </ExtendedNextLink>
                    ))}
                </div>
            ) : (
                <CategoryDetailAdvancedSeoCategoriesSlider readyCategorySeoMixLinks={readyCategorySeoMixLinks} />
            )}
        </>
    );
};

export default CategoryDetailAdvancedSeoCategories;
